import React from 'react';
import { ENABLED_FILTERS } from '../../../../utils/constants/enable-filter-values';
import SelectCheckbox from '../../../../shared/select-checkbox';


interface IInvoiceFilters {
    selectedStatus?: any;
    partners: any;
    selectedPartner?: any;
    onClickFilter: (value: any, type?: string) => void;
}

const InvoiceFilters = ({
    selectedStatus,
    partners,
    selectedPartner,
    onClickFilter
}: IInvoiceFilters) => {
    return (
        <div>
            <div className='grid grid-cols-4 gap-4'>
                <SelectCheckbox
                    name='Partner'
                    dataQa={'partner-filter'}
                    placeholder={''}
                    options={partners || []}
                    selectStyle={{ backgroundColor: '#ffffffa4', borderRadius: '4px', minWidth: 200 }}
                    onChangeSelectedOption={onClickFilter}
                    selectedOption={selectedPartner}
                    uniqueName={'partner'}
                />
                <SelectCheckbox
                    name='Invoiced'
                    dataQa={'status-filter'}
                    placeholder={''}
                    options={ENABLED_FILTERS || []}
                    selectStyle={{ backgroundColor: '#ffffffa4', borderRadius: '4px', minWidth: 200 }}
                    onChangeSelectedOption={onClickFilter}
                    selectedOption={selectedStatus}
                    uniqueName={'status'}
                />
            </div>
        </div>
    );
};

export default InvoiceFilters;
